import React, { FC } from 'react';

import Icon from '../icons/Button/IconButton';
import XClose from '../icons/XClose/XClose';

export interface DismissProps {
  fill?: string;
  onClick?: () => void;
}

const Dismiss: FC<DismissProps> = ({ onClick, fill }) => {
  return (
    <Icon onClick={onClick} s={{ padding: 0 }} ariaLabel="close">
      <XClose s={{ fill: fill || '#9e9e9e' }} />
    </Icon>
  );
};

export default Dismiss;
